<template>
  <div :style="offsetStyle" class="project-page-header">
    <div class="d-flex">
      <h1>
        <router-link :to="{ name: 'projects.index' }">
          <font-awesome-icon v-b-popover.hover.right="'ย้อนกลับ'" :icon="['far', 'arrow-alt-circle-left']" class="back-button" />
        </router-link>
        {{ project.name }}
      </h1>
      <div class="tools">
        <pdf-download-dropdown />
      </div>
    </div>
    <div>
      <status-chart :route="filterRoute(project.route)" :status="project.status" :group="project.group" :project="project" />
    </div>
  </div>
</template>

<script>
import StatusChart from './StatusChart'
import PdfDownloadDropdown from './PdfDownloadDropdown'

export default {
  components: {
    StatusChart, PdfDownloadDropdown
  },
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) },
    isSidebarMinimized () { return this.$store.state.layout.isSidebarMinimized },
    isSidebarEnabled () { return this.$store.state.layout.isSidebarEnabled },
    offsetStyle () {
      if (!this.isSidebarEnabled) { return { left: 0 } }
      return this.isSidebarMinimized ? { left: '45px' } : { left: '220px' }
    }
  },
  methods: {
    filterRoute (route) {
      let index = 0
      for (let i = 0; i < route.length; i++) {
        if (route[i]['code'] === 3) {
          index = i
          if (route[index]['state'] === 'passed') {
            return route.slice(index)
          } else {
            return route.slice(0, index + 1)
          }
        }
      }
      return route
    }
  }
}
</script>

<style lang="scss" scoped>
.project-page-header {
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
  padding: 0 15px 15px 15px;
  position: fixed;
  top: 49px;
  right: 0;
  z-index: 2;
}

h1 {
  font-size: 1.4rem;
  line-height: 55px;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0;
  margin: 0;
}

.back-button {
  font-size: 34px;
  opacity: 0.8;
  color: #343a40;

  &:hover {
    opacity: 1;
  }
}
</style>
